var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_698_24875)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.506 17.423a.88.88 0 01.523.174c.06.05 3.438 2.866 5.532 4.538-.79-2.642-2.045-7.037-2.061-7.092a.795.795 0 01-.041-.262c0-.284.136-.555.364-.726.05-.037 3.519-2.516 5.644-4.055h-6.964c-.497 0-.901-.607-.98-.848A875.898 875.898 0 0012.5 2.214a988.845 988.845 0 00-2.02 6.924c-.086.265-.483.862-.981.862H2.533c2.124 1.539 5.587 4.017 5.63 4.048a.917.917 0 01.332 1.006c-.013.046-1.27 4.438-2.056 7.08 2.09-1.672 5.463-4.483 5.505-4.518a.94.94 0 01.562-.193zM19.5 24a.501.501 0 01-.297-.098c-1.42-1.047-5.995-4.855-6.705-5.447-.628.524-5.271 4.389-6.7 5.446a.501.501 0 01-.775-.553c.54-1.697 2.32-7.901 2.499-8.529-.588-.421-5.407-3.872-6.82-4.918A.5.5 0 011 9h8.4a.724.724 0 00.129-.167c.01-.038 1.925-6.689 2.494-8.485a.5.5 0 01.954-.001c.574 1.796 2.484 8.448 2.504 8.514A.887.887 0 0015.6 9H24a.5.5 0 01.298.901c-1.41 1.044-6.222 4.487-6.822 4.916.176.619 1.956 6.832 2.5 8.53A.503.503 0 0119.5 24z",
    fill: "#999"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_698_24875"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.5)",
    d: "M0 0h24v24H0z"
  })))));
}
SvgStar.displayName = 'Star';
export default SvgStar;